module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#stories",
      toString: function () {
        return this.url;
      }
    }